import CsFormItem from "./form-item";
import CsFormCommon from "./form-common";
import CsFormBottom from "./form-bottom";
import Manager from "./manager";
import { deepClone } from "./utils";
export default {
  name: "CsForm",
  components: { CsFormBottom },
  mixins: [CsFormItem, Manager, CsFormCommon],
  props: {
    rule: {
      type: Array,
      required: true,
    },
    action: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    option: {
      type: Object,
      default: () => {
        return {};
      },
    },
    value: Object,
  },
  data() {
    const parseRule = (rule) => {
      // 同步action配置
      const actionOn = this.action[rule.field] || {};
      if (actionOn) {
        rule.on = Object.assign({}, rule.on || {}, actionOn);
      }
      // 同步components配置
      if (Object.prototype.hasOwnProperty.call(this.components, rule.type)) {
        rule.component = this.components[rule.type];
        rule.type = "custom";
      } else if (
        Object.prototype.hasOwnProperty.call(
          this.$COMMONUI.components,
          rule.type
        )
      ) {
        // 同步全局globalComponents配置
        rule.component = this.$COMMONUI.components[rule.type];
        rule.type = "custom";
      }
    };

    const _rule = deepClone(this.rule);
    const formData = {};
    const ruleList = [];
    _rule.forEach((item) => {
      if (item.type === "row") {
        item.children &&
          item.children.forEach((child) => {
            parseRule(child);
            formData[child.field] = child.value;
            ruleList.push(child);
          });
      } else {
        parseRule(item);
        ruleList.push(item);
        formData[item.field] = item.value;
      }
    });
    return {
      formData,
      renderRule: _rule,
      ruleList,
    };
  },
  render(h) {
    return (
      <div>
        <el-form
          class="cs-form"
          ref="form"
          attrs={{ model: this.formData, ...this.formAttrs }}
        >
          {this.renderRule.map((item) => {
            return this.renderFormItem(h, item);
          })}
          <cs-form-bottom
            loading={this.loading}
            class="cs-form-bottom-layout"
            attrs={{
              buttons: this.formAttrs.buttons,
              buttonsAlign: this.formAttrs.buttonsAlign,
            }}
            on={{ onSubmit: this.onSubmit, onReset: this.onReset }}
          ></cs-form-bottom>
        </el-form>
      </div>
    );
  },
};
